"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// packages/ag-charts-locale/src/es-ES.ts
var es_ES_exports = {};
__export(es_ES_exports, {
  AG_CHARTS_LOCALE_ES_ES: () => AG_CHARTS_LOCALE_ES_ES
});
module.exports = __toCommonJS(es_ES_exports);
var AG_CHARTS_LOCALE_ES_ES = {
  ariaAnnounceChart: "gr\xE1fico, ${seriesCount}[number] series",
  ariaAnnounceFlowProportionLink: "enlace ${index} de ${count}, de ${from} a ${to}, ${sizeName} ${size}",
  ariaAnnounceFlowProportionNode: "nodo ${index} de ${count}, ${description}",
  ariaAnnounceGaugeChart: "gr\xE1fico de veloc\xEDmetro, ${caption}",
  ariaAnnounceHierarchyChart: "gr\xE1fico de jerarqu\xEDa, ${caption}",
  ariaAnnounceHierarchyDatum: "nivel ${level}[number], ${count}[number] hijos, ${description}",
  ariaAnnounceHoverDatum: "${datum}",
  ariaDescriptionLegendItem: "Presiona Espacio o Enter para alternar la visibilidad",
  ariaLabelAddHorizontalLine: "A\xF1adir l\xEDnea horizontal",
  ariaLabelAnnotationOptionsToolbar: "Opciones de anotaci\xF3n",
  ariaLabelAnnotationSettingsDialog: "Configuraci\xF3n de anotaci\xF3n",
  ariaLabelColorPicker: "Selector de color",
  ariaLabelFinancialCharts: "Gr\xE1ficos financieros",
  ariaLabelLegend: "Leyenda",
  ariaLabelLegendItem: "${label}, Elemento de la leyenda ${index}[number] de ${count}[number]",
  ariaLabelLegendItemUnknown: "Elemento desconocido de la leyenda",
  ariaLabelLegendPageNext: "Siguiente p\xE1gina de leyenda",
  ariaLabelLegendPagePrevious: "P\xE1gina anterior de la leyenda",
  ariaLabelLegendPagination: "Paginaci\xF3n de la leyenda",
  ariaLabelNavigator: "Navegador",
  ariaLabelNavigatorMaximum: "M\xE1ximo",
  ariaLabelNavigatorMinimum: "M\xEDnimo",
  ariaLabelNavigatorRange: "Rango",
  ariaLabelRangesToolbar: "Rangos",
  ariaLabelSettingsTabBar: "Configuraci\xF3n",
  ariaLabelZoomToolbar: "Zoom",
  ariaValuePanRange: "${min}[percent0to2dp] a ${max}[percent0to2dp]",
  contextMenuDownload: "Descargar",
  contextMenuPanToCursor: "Desplazar hasta aqu\xED",
  contextMenuToggleOtherSeries: "Alternar Otras Series",
  contextMenuToggleSeriesVisibility: "Alternar visibilidad",
  contextMenuZoomToCursor: "Acercar aqu\xED",
  dialogHeaderChannel: "Canal",
  dialogHeaderDatePriceRange: "Fecha y Precio",
  dialogHeaderDateRange: "Rango de fechas",
  dialogHeaderFibonacciRange: "Fib Retroceso",
  dialogHeaderLine: "L\xEDnea",
  dialogHeaderPriceRange: "Rango de precios",
  dialogHeaderText: "Texto",
  dialogInputAlign: "Alinear",
  dialogInputColorPicker: "Color",
  dialogInputColorPickerAltText: "Color del texto",
  dialogInputExtendAbove: "Extender por encima",
  dialogInputExtendBelow: "Extender debajo",
  dialogInputExtendChannelEnd: "Extender fin del canal",
  dialogInputExtendChannelStart: "Extender inicio del canal",
  dialogInputExtendLeft: "Extender hacia la izquierda",
  dialogInputExtendLineEnd: "Extender el final de la l\xEDnea",
  dialogInputExtendLineStart: "Extender inicio de la l\xEDnea",
  dialogInputExtendRight: "Extender a la derecha",
  dialogInputFibonacciBands: "Bandas",
  dialogInputFibonacciBandsAltText: "Bandas de Fibonacci",
  dialogInputFillColorPicker: "Rellenar",
  dialogInputFillColorPickerAltText: "Color de relleno",
  dialogInputFontSize: "Tama\xF1o",
  dialogInputFontSizeAltText: "Tama\xF1o de Fuente",
  dialogInputLineStyle: "Guion",
  dialogInputPosition: "Posici\xF3n",
  dialogInputReverse: "Inverso",
  dialogInputShowFill: "Mostrar relleno",
  dialogInputStrokeWidth: "Grosor",
  dialogInputStrokeWidthAltText: "Grosor de l\xEDnea",
  iconAltTextAlignCenter: "Centrar",
  iconAltTextAlignLeft: "Izquierda",
  iconAltTextAlignRight: "Derecha",
  iconAltTextClose: "Cerrar",
  iconAltTextLineStyleDashed: "L\xEDneas largas",
  iconAltTextLineStyleDotted: "L\xEDnea corta discontinua",
  iconAltTextLineStyleSolid: "S\xF3lido",
  iconAltTextPositionBottom: "Inferior",
  iconAltTextPositionCenter: "Centro",
  iconAltTextPositionTop: "Parte superior",
  inputTextareaPlaceholder: "Agregar texto",
  measurerDateRangeBars: "${value}[number] barras",
  measurerPriceRangePercent: "${value}[percent]",
  measurerPriceRangeValue: "${value}[number]",
  measurerVolume: "Vol ${value}",
  overlayLoadingData: "Cargando datos...",
  overlayNoData: "No hay datos para mostrar",
  overlayNoVisibleSeries: "No hay series visibles",
  overlayUnsupportedBrowser: "Versi\xF3n del navegador no compatible. Por favor, actualice su navegador.",
  seriesHistogramTooltipCount: "${yName} (cuenta)",
  seriesHistogramTooltipFrequency: "Frecuencia",
  seriesHistogramTooltipMean: "${yName} (media)",
  seriesHistogramTooltipSum: "${yName} (suma)",
  toolbarAnnotationsArrow: "Flecha",
  toolbarAnnotationsArrowDown: "Flecha hacia abajo",
  toolbarAnnotationsArrowUp: "Flecha Arriba",
  toolbarAnnotationsCallout: "Anotaci\xF3n",
  toolbarAnnotationsClearAll: "Borrar todo",
  toolbarAnnotationsComment: "Comentario",
  toolbarAnnotationsDatePriceRange: "Fecha y Precio",
  toolbarAnnotationsDateRange: "Rango de fechas",
  toolbarAnnotationsDelete: "Eliminar",
  toolbarAnnotationsDisjointChannel: "Canal disjunto",
  toolbarAnnotationsDragHandle: "Arrastrar barra de herramientas",
  toolbarAnnotationsFibonacciAnnotations: "Fibonacci",
  toolbarAnnotationsFibonacciRetracement: "Retroceso de Fib",
  toolbarAnnotationsFibonacciRetracementTrendBased: "Tendencia basada en Fibonacci",
  toolbarAnnotationsFillColor: "Color de Relleno",
  toolbarAnnotationsHorizontalLine: "L\xEDnea horizontal",
  toolbarAnnotationsLineAnnotations: "L\xEDneas de tendencia",
  toolbarAnnotationsLineColor: "Color de l\xEDnea",
  toolbarAnnotationsLineStrokeWidth: "Ancho del trazo de l\xEDnea",
  toolbarAnnotationsLineStyle: "Estilo de l\xEDnea",
  toolbarAnnotationsLock: "Bloquear",
  toolbarAnnotationsMeasurerAnnotations: "Medidores",
  toolbarAnnotationsNote: "Nota",
  toolbarAnnotationsParallelChannel: "Canal Paralelo",
  toolbarAnnotationsPriceRange: "Rango de precios",
  toolbarAnnotationsQuickDatePriceRange: "Medir",
  toolbarAnnotationsSettings: "Configuraciones",
  toolbarAnnotationsShapeAnnotations: "Flechas",
  toolbarAnnotationsText: "Texto",
  toolbarAnnotationsTextAnnotations: "Anotaciones de texto",
  toolbarAnnotationsTextColor: "Color del texto",
  toolbarAnnotationsTextSize: "Tama\xF1o del texto",
  toolbarAnnotationsTrendLine: "L\xEDnea de tendencia",
  toolbarAnnotationsUnlock: "Desbloquear",
  toolbarAnnotationsVerticalLine: "L\xEDnea Vertical",
  toolbarRange1Month: "1M",
  toolbarRange1MonthAria: "1 mes",
  toolbarRange1Year: "1A",
  toolbarRange1YearAria: "1 a\xF1o",
  toolbarRange3Months: "3M",
  toolbarRange3MonthsAria: "3 meses",
  toolbarRange6Months: "6M",
  toolbarRange6MonthsAria: "6 meses",
  toolbarRangeAll: "Todo",
  toolbarRangeAllAria: "Todo",
  toolbarRangeYearToDate: "A\xF1o en curso",
  toolbarRangeYearToDateAria: "A\xF1o hasta la fecha",
  toolbarSeriesTypeCandles: "Velas",
  toolbarSeriesTypeDropdown: "Tipo de Gr\xE1fico",
  toolbarSeriesTypeHighLow: "Alto Bajo",
  toolbarSeriesTypeHLC: "HLC",
  toolbarSeriesTypeHollowCandles: "Velas Huecas",
  toolbarSeriesTypeLine: "L\xEDnea",
  toolbarSeriesTypeLineWithMarkers: "L\xEDnea con marcadores",
  toolbarSeriesTypeOHLC: "OHLC",
  toolbarSeriesTypeStepLine: "L\xEDnea escalonada",
  toolbarZoomPanEnd: "Desplazar hasta el final",
  toolbarZoomPanLeft: "Desplazar a la izquierda",
  toolbarZoomPanRight: "Desplazar a la derecha",
  toolbarZoomPanStart: "Mover al inicio",
  toolbarZoomReset: "Restablecer el zoom",
  toolbarZoomZoomIn: "Acercar",
  toolbarZoomZoomOut: "Alejar",
  tooltipPaginationStatus: "${index}[number] de ${count}[number]"
};
//# sourceMappingURL=es-ES.cjs.js.map
